import React from 'react';

const AiraBotDark = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <rect width="32" height="32" fill="#04265E" rx="16" />
      <mask
        id="mask0_140_39219"
        width="28"
        height="28"
        x="2"
        y="2"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
      >
        <rect width="28" height="28" x="2" y="2" fill="#04265E" rx="14" />
      </mask>
      <g fillRule="evenodd" clipRule="evenodd" mask="url(#mask0_140_39219)">
        <path
          fill="#5FBBE8"
          d="M9.298 14.838a2.52 2.52 0 01-.666-.666 2.44 2.44 0 01-.343-2.022 2.449 2.449 0 011.373-1.572c.188-.084.389-.146.598-.182.984 2.623-.962 4.442-.962 4.442z"
        />
        <path
          fill="#5FAEDE"
          d="M9.304 14.827a2.521 2.521 0 01-.662-.667 32.56 32.56 0 001.017-3.591c.187-.084.386-.146.594-.181l-.95 4.439z"
        />
        <path
          fill="#5FBBE8"
          d="M23.114 15.003c.39 3.421-7.135 5.987-11.134 4.624-1.111-.378-1.95-1.06-2.272-2.11-1.482-4.833.936-9.965 4.687-10.668 1.36-.255 3.055-.033 4.593.873 1.972 1.16 3.69 3.441 4.126 7.28zM8.6 12.494c-.03-.01-.745-.244-1.41-.983C6.58 10.835 5.9 9.59 6.12 7.5l.367.04c-.163 1.559.16 2.806.963 3.707.598.671 1.256.89 1.262.892l-.111.354z"
        />
        <path
          fill="#294F81"
          d="M7.21 6.92a.882.882 0 11-1.733.324.882.882 0 011.733-.325zM20.574 12.406c.127.678-.54 1.236-1.454 1.664-.963.451-2.2.76-3.072.914-1.248.222-3.693.456-4.708-.17-.238-.147-.397-.342-.444-.594a2.663 2.663 0 01.448-2.032c.405-.575 1.034-1 1.79-1.143l4.203-.787a2.81 2.81 0 012.355.623c.446.383.767.91.882 1.525z"
        />
        <path
          fill="#33487A"
          d="M20.572 12.397c.128.682-.536 1.241-1.445 1.67-.959.452-2.19.76-3.059.913-1.243.221-3.678.452-4.69-.18 2.444-.534 6.547-1.725 8.313-3.937.444.386.765.916.881 1.534z"
        />
        <path
          fill="#5FAEDE"
          d="M23.114 14.994c.39 3.426-7.132 5.992-11.131 4.627 2.278-.047 9.007-.473 9.595-3.871.506-2.922-1.436-6.331-2.591-8.046 1.971 1.161 3.69 3.446 4.127 7.29z"
        />
        <path
          fill="#B1ECED"
          d="M10.696 10.991c.251.227 1.385-.56 2.1-1.326.688-.735 1.328-1.81 1.1-2.038-.203-.203-1.055.3-1.573.712-1.158.924-1.9 2.404-1.627 2.652zM9.922 16.598c.2.903.906 1.664 1.116 1.564.22-.105-.078-1.173-.296-1.75-.063-.165-.447-1.178-.686-1.129-.189.04-.263.73-.134 1.315z"
        />
        <path
          fill="#393760"
          d="M19.602 12.002a1.25 1.25 0 11-2.455.46 1.25 1.25 0 012.455-.46z"
        />
        <path
          fill="#46AED2"
          d="M18.103 10.791a1.471 1.471 0 00-.983 2.213c.316.516.929.788 1.524.676a1.471 1.471 0 00.936-2.283 1.47 1.47 0 00-1.477-.606zm.04.21a1.254 1.254 0 11.462 2.466 1.254 1.254 0 01-.463-2.465z"
        />
        <path
          fill="#2F4572"
          d="M19.363 11.524c-.244 1.194-1.37 1.372-2.053 1.367a1.264 1.264 0 01-.163-.423 1.24 1.24 0 01.975-1.46c.491-.093.971.124 1.241.516z"
        />
        <path
          fill="#B1ECED"
          d="M18.226 11.848a.404.404 0 11-.794.149.404.404 0 01.794-.149zM19.405 12.267c.077.033.065.484-.216.708-.25.2-.637.16-.66.082-.018-.057.17-.109.452-.359.297-.263.37-.454.424-.431z"
        />
        <path
          fill="#393760"
          d="M14.184 13.015a1.25 1.25 0 11-2.455.46 1.25 1.25 0 012.455-.46z"
        />
        <path
          fill="#46AED2"
          d="M12.685 11.8a1.471 1.471 0 00-.983 2.213 1.471 1.471 0 102.46-1.607 1.47 1.47 0 00-1.477-.606zm.04.21a1.254 1.254 0 11.462 2.466 1.254 1.254 0 01-.463-2.465z"
        />
        <path
          fill="#2F4572"
          d="M13.945 12.537c-.244 1.194-1.37 1.372-2.053 1.367a1.27 1.27 0 01-.162-.423 1.24 1.24 0 01.974-1.46c.491-.093.971.124 1.241.516z"
        />
        <path
          fill="#B1ECED"
          d="M12.81 12.861a.404.404 0 11-.795.149.404.404 0 01.795-.149zM13.987 13.284c.077.033.065.484-.216.708-.25.2-.637.16-.66.082-.017-.057.17-.109.452-.359.298-.263.37-.454.424-.431z"
        />
        <path
          fill="#296ABD"
          d="M15.647 10.84c.026.073-.495.355-1.06.511-.917.254-1.82.142-1.826.045-.003-.045.585-.16 1.762-.39.944-.184 1.11-.205 1.124-.166zM5.742 7.02a.478.478 0 10.892-.341.478.478 0 00-.892.34z"
        />
        <path
          fill="#5FBBE8"
          d="M24.092 22.799c.637 3.399-1.007 7.84-4.809 8.552-2.355.442-4.564-.632-6.057-2.341-.918-1.05-1.567-2.338-1.815-3.662-.653-3.482 3.192-4.031 5.61-4.484 2.65-.497 5.758-1.29 6.806 1.06.114.254.203.544.265.875z"
        />
        <path
          fill="#5FAEDE"
          d="M24.103 22.855c.639 3.408-1.005 7.86-4.809 8.573-2.356.442-4.566-.636-6.062-2.35 2.57.668 9.731 1.706 10.606-7.1.114.254.203.545.265.877z"
        />
        <path
          fill="#B1ECED"
          d="M12.472 23.766c-.345.889.217 1.956 1.149 2.241.985.302 2.127-.348 2.285-1.345.15-.947-.646-1.827-1.574-1.942-.743-.092-1.573.307-1.86 1.046z"
        />
        <path
          fill="#5FBBE8"
          d="M9.7 23.308c.82.218.652 1.18.01 2.458-.767 1.526-3.331 3.639-5.297 3.108a2.237 2.237 0 01-.521-.213c-2.005-1.134 3.834-5.162 4.774-5.335.445-.083.785-.084 1.034-.018z"
        />
        <path
          fill="#5FAEDE"
          d="M9.691 23.282c.826.22.656 1.187.01 2.472-.771 1.534-3.351 3.659-5.329 3.125 1.741-.625 4.555-2.148 5.319-5.597z"
        />
        <path
          fill="#B1ECED"
          d="M4.695 26.624c.41-.354 1.142-.873 1.273-.74.134.138-.355.96-1.05 1.506-.474.372-1.13.684-1.236.551-.12-.15.478-.856 1.013-1.317z"
        />
        <path
          fill="#5FBBE8"
          d="M24.88 21.632c.34.786 1.27.474 2.444-.357 1.401-.992 3.117-3.863 2.296-5.744a2.244 2.244 0 00-.289-.487c-1.425-1.83-4.556 4.592-4.588 5.555-.015.456.034.795.137 1.033z"
        />
        <path
          fill="#5FAEDE"
          d="M24.92 21.634c.337.778 1.261.469 2.427-.355 1.392-.983 3.098-3.829 2.284-5.692-.358 1.802-1.439 4.789-4.711 6.047z"
        />
        <path
          fill="#B1ECED"
          d="M27.431 16.25c-.291.463-.7 1.274-.548 1.384.157.113.903-.5 1.343-1.277.3-.53.514-1.233.366-1.318-.167-.096-.78.607-1.161 1.211z"
        />
        <path
          fill="#33487A"
          d="M13.412 16.075a7.44 7.44 0 001.44.308c.48.053.961.048 1.43-.027.234-.04.464-.098.69-.171.225-.076.442-.173.657-.281a6.715 6.715 0 001.2-.844 3.697 3.697 0 01-1.05 1.094 3.848 3.848 0 01-.686.361c-.06.025-.122.044-.183.066-.062.022-.124.04-.187.057-.125.036-.253.06-.38.084a4.1 4.1 0 01-1.54-.052 4.38 4.38 0 01-.727-.232 3.685 3.685 0 01-.343-.163 2.584 2.584 0 01-.321-.2z"
        />
        <path
          fill="#D36E52"
          d="M32.472 17.46a.842.842 0 01-1.075.516l-7.61-2.685a.846.846 0 01-.515-1.078.842.842 0 011.074-.516l7.61 2.685c.44.155.67.638.516 1.078z"
        />
        <path
          fill="#33487A"
          d="M24.543 10.851a5.365 5.365 0 11-10.546 1.976 5.365 5.365 0 0110.546-1.976z"
        />
        <path
          fill="#294F81"
          d="M23.341 8.018a7.54 7.54 0 01-.896 1.735c-1.577 2.278-4.2 3.456-6.178 4.048-.716.216-1.347.354-1.814.439a5.495 5.495 0 013.951-7.768 5.5 5.5 0 014.937 1.546z"
        />
        <path
          fill="#5FBBE8"
          d="M16.607 15.177s3.027.264 6.212-1.164c0 0-1.81 3.535-6.212 1.164z"
        />
        <path
          fill="#E4B166"
          d="M19.972 15.569a3.807 3.807 0 01-4.437-3.036 3.806 3.806 0 013.036-4.437 3.807 3.807 0 014.437 3.036 3.806 3.806 0 01-3.036 4.437zm3.336-7.703a5.658 5.658 0 10-8.072 7.933 5.658 5.658 0 008.072-7.933z"
        />
        <path
          fill="#393760"
          d="M21.655 11.391a2.425 2.425 0 11-4.767.894 2.425 2.425 0 014.767-.894z"
        />
        <path
          fill="#46AED2"
          d="M18.793 9.085a2.832 2.832 0 00-1.891 4.26 2.845 2.845 0 002.934 1.301 2.832 2.832 0 001.8-4.395 2.83 2.83 0 00-2.843-1.166zm.076.406a2.414 2.414 0 012.82 1.93 2.416 2.416 0 11-2.82-1.93z"
        />
        <path
          fill="#2F4572"
          d="M21.338 10.501c-.49 2.292-2.708 2.642-4.051 2.638a2.374 2.374 0 01-.316-.81c-.249-1.3.616-2.556 1.931-2.807a2.423 2.423 0 012.436.979z"
        />
        <path
          fill="#B1ECED"
          d="M19.05 11.058a.808.808 0 11-1.59.298.808.808 0 011.59-.298zM21.279 11.992c.143.063.125.92-.396 1.343-.462.377-1.182.3-1.227.15-.032-.108.315-.205.839-.678.551-.498.684-.859.784-.815z"
        />
        <path
          fill="#5FBBE8"
          d="M27.541 14.844s.189 2.163 2.393.824c0 0-.332-1.894-2.393-.824z"
        />
        <path
          fill="#B1ECED"
          d="M28.734 15.259c.16.189.318.522.207.642-.145.155-.775-.022-.968-.44-.077-.17-.109-.436.014-.53.16-.122.54.082.747.328z"
        />
        <g fill="#F3E0B3">
          <path d="M14.661 13.75a.212.212 0 01-.242-.15c-.004-.009-.008-.022-.013-.04-.551-1.77-.294-3.524.704-4.813 1.335-1.722 3.265-2.007 3.825-2.054a.212.212 0 11.035.424c-.516.042-2.296.305-3.523 1.89-1.25 1.613-.934 3.466-.635 4.427l.014.047a.213.213 0 01-.165.269zM22.914 14.962a.213.213 0 01-.21-.333c.955-1.32 1.185-2.974.616-4.422a.21.21 0 11.39-.155c.623 1.584.374 3.388-.665 4.827a.21.21 0 01-.131.083zM20.136 16.464c-.394.074-.77.097-1.086.083a.214.214 0 01-.203-.223.21.21 0 01.219-.204c.86.038 2.067-.234 2.827-.925a.209.209 0 01.297.017.215.215 0 01-.015.302c-.579.527-1.338.819-2.039.95z" />
        </g>
        <path
          fill="#F48B4D"
          d="M27.16 15.443a.184.184 0 01-.099-.009l-2.245-.84a.19.19 0 01-.111-.242.185.185 0 01.24-.111l2.245.84a.19.19 0 01.11.242.186.186 0 01-.14.12zM31.966 17.164a.19.19 0 01-.09-.005l-2.131-.645a.184.184 0 01-.123-.23.19.19 0 01.235-.123l2.131.645c.1.03.154.133.123.23a.188.188 0 01-.145.128z"
        />
      </g>
    </svg>
  );
};

export default AiraBotDark;
